import {Platform,useWindowDimensions} from 'react-native';

/** Web layout is independent of the user's mobile colour/accessibility choice. */
export function useDesktop(){
  const {width,height}=useWindowDimensions();
  return {desktop:Platform.OS==='web'&&width>=1000,width,height};
}
